module.exports = __webpack_public_path__ + "static/img/LATINA-MAPLE.db4d8ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/LATINA-MAPLE.png
// module id = lEpG
// module chunks = 0